'use client';

import { useEffect, useRef, useState } from 'react';
import { IconInfo } from '@repo/svgs';
import { ModalTrigger } from '@/components/ui/ModalTrigger';
import { InfoPopover } from '@/components/ui/InfoPopover';
import { AboutBostonViolationsModal } from './modals/AboutBostonViolationsModal';

export function AboutBostonViolationsTrigger() {
  const anchorRef = useRef<HTMLButtonElement | null>(null);
  const [isDesktop, setIsDesktop] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const update = () => setIsDesktop(window.innerWidth >= 768);
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  if (!isDesktop) {
    return (
      <ModalTrigger
        label="About violations, complaints, and requests"
        content={<AboutBostonViolationsModal />}
        urlKey="about-boston-violations"
      >
        <IconInfo className="w-4 h-4 icon-primary cursor-pointer" />
      </ModalTrigger>
    );
  }

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        aria-label="About violations, complaints, and requests"
        className="inline-flex"
        onClick={() => setOpen(true)}
      >
        <IconInfo className="w-4 h-4 icon-primary cursor-pointer" />
      </button>
      <InfoPopover
        open={open}
        onOpenChange={setOpen}
        onClose={() => setOpen(false)}
        label="About violations, complaints, and requests"
        anchorRef={anchorRef}
        placement="below"
        contentClassName="w-[480px]"
        align="right"
        offsetY={32}
        offsetX={32}
      >
        <AboutBostonViolationsModal />
      </InfoPopover>
    </>
  );
}
